
export const slideVariants = {
  hiddenRight: { x: '100%', opacity: 0 },
  hiddenLeft: { x: '-100%', opacity: 0 },
  visible: { 
    x: 0, 
    opacity: 1,
    transition: { 
      type: 'spring',
      stiffness: 300,
      damping: 30,
      mass: 1,
      when: "beforeChildren",
      staggerChildren: 0.1
    } 
  },
  exitLeft: { 
    x: '-100%', 
    opacity: 0,
    transition: { ease: 'easeInOut' } 
  },
  exitRight: { 
    x: '100%', 
    opacity: 0,
    transition: { ease: 'easeInOut' } 
  }
};

export const imageVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { 
      type: 'spring',
      stiffness: 300,
      damping: 25
    } 
  }
};
